import { useMarket } from "@context/marketContext";
import getAutocomplete from "@server/requests/elevate/getAutocomplete";
import { fetchAutocomplete } from "@server/requests/product";
import getSearchEngineUserUid from "@server/utils/getSearchEngineUserUid";
import type { UseQueryResult } from "@tanstack/react-query";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { Product } from "types";
import type { Loop54AutocompleteResponse } from "types/loop54";

import { FEATURE_FLAGS } from "@/config/featureFlags";

const useAutocomplete = ({
  query,
}: {
  query: string;
  enabled?: boolean;
}): UseQueryResult<
  (Loop54AutocompleteResponse & { products?: Product[] }) | null,
  Error
> => {
  const { market } = useMarket().state;

  const searchEngineUser = getSearchEngineUserUid();

  const response = useQuery({
    queryKey: ["autocomplete", query],
    queryFn: ({ signal }) =>
      FEATURE_FLAGS.elevate
        ? getAutocomplete(market, {
            q: query,
          })
        : fetchAutocomplete({
            query,
            marketConfig: market,
            searchEngineUser,
            signal,
          }),
    placeholderData: keepPreviousData,
    enabled: !!query,
  });

  return response;
};

export default useAutocomplete;
